import type { ReactNode } from 'react';

export default function SessionPlayerShell({ children }: { children: ReactNode }) {
  return (
    <div
      className="min-h-dvh"
      style={{
        background: 'var(--color-bg)',
        color: 'var(--color-text)',
        fontFamily: 'var(--font-sans)',
      }}
    >
      {children}
    </div>
  );
}
